<template>
  <div class="skill-step">
    <h2 class="step-title">Choose Your Modality</h2>

    <div class="skill-cards">
      <div class="skill-card" :class="{ selected: chosen === 'tarot' }" @click="choose('tarot')">
        <div class="skill-icon">🃏</div>
        <div class="skill-name">Tarot</div>
        <div class="skill-desc">Readings through the archetypal language of cards. Every card a mirror, every spread a map.</div>
      </div>
      <div class="skill-card" :class="{ selected: chosen === 'astrology' }" @click="choose('astrology')">
        <div class="skill-icon">♄</div>
        <div class="skill-name">Astrology</div>
        <div class="skill-desc">Daily drops and horoscopes rooted in the movement of planets. The sky as a living text.</div>
      </div>
      <div class="skill-card both" :class="{ selected: chosen === 'both' }" @click="choose('both')">
        <div class="skill-icon">✦</div>
        <div class="skill-name">Both Paths</div>
        <div class="skill-desc">Walk the full spectrum. Tarot readings and astrological drops working in concert.</div>
      </div>
    </div>

    <div class="step-actions" v-if="chosen">
      <button class="primary-btn" @click="proceed">Continue →</button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { static_store } from '@/store'

const props = defineProps({ provisioningId: Number })
const emit = defineEmits(['skill-chosen', 'next'])

const chosen = ref('')

async function choose(skill) {
  chosen.value = skill
  emit('skill-chosen', skill)
  const token = localStorage.getItem('authToken')
  try {
    await axios.post(
      `${static_store.apiUrl}/reader/become-mystic/update/${props.provisioningId}/`,
      { chosen_skill: skill },
      { headers: { Authorization: `Token ${token}` } }
    )
  } catch (e) {
    // silent
  }
}

function proceed() {
  emit('next')
}
</script>

<style scoped>
.skill-step { color: #E8D8FF; }
.step-title { font-size: 20px; font-weight: 500; color: #7DE8CC; margin-bottom: 24px; }
.skill-cards { display: flex; flex-direction: column; gap: 12px; margin-bottom: 24px; }
.skill-card { padding: 18px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; cursor: pointer; transition: all 0.2s; }
.skill-card:hover { border-color: rgba(125,232,204,0.25); }
.skill-card.selected { background: rgba(125,232,204,0.08); border-color: rgba(125,232,204,0.4); }
.skill-icon { font-size: 24px; margin-bottom: 8px; }
.skill-name { font-size: 16px; font-weight: 500; color: #7DE8CC; margin-bottom: 6px; }
.skill-desc { font-size: 12px; color: rgba(255,255,255,0.4); line-height: 1.6; }
.primary-btn { width: 100%; padding: 14px; background: rgba(50,192,158,0.12); border: 1px solid rgba(50,192,158,0.35); border-radius: 10px; color: #7DE8CC; font-size: 15px; cursor: pointer; font-family: inherit; transition: all 0.2s; }
</style>
